import * as React from 'react';
import {
  Box,
  // Button,
  // Divider,
  Drawer,
  List,
  ListItem,
  // ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectShowTemporaryDrawer } from '../../store/system/selectors';
import { setShowTemporaryDrawer } from '../../store/system/actions';

const drawerAnchor = 'right';

export default function TemporaryDrawer() {
  const dispatch = useDispatch();
  const showTemporaryDrawer = useSelector(selectShowTemporaryDrawer);
  const styles = useStyles();

  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    dispatch(setShowTemporaryDrawer(false));
  };

  const list = () => (
    <Box
      sx={{ width: 200 }}
      role="presentation"
      onClick={toggleDrawer}
      onKeyDown={toggleDrawer}
    >
      <List>
        {['Обновления проекта', 'О Прахупаде'].map((text, index) => (
          <ListItem
            button
            key={text}
            classes={{
              gutters: styles.listItemGutters,
            }}
          >
            <ListItemText
              classes={{
                root: styles.listItemTextRoot,
              }}
              primary={text}
            />
          </ListItem>
        ))}
      </List>
      <div className={styles.container}>
        <div className={styles.cta}>
          <div className={styles.subscribe}>Подпишись на рассылку</div>
          <div className={styles.newText}>новые лекции, новый функционал</div>
          <div className={styles.button} onClick={() => alert('Подписаться')}>
            Подписаться
          </div>
        </div>
        <div
          className={styles.buttonFull}
          onClick={() => alert('Поддержите проект')}
        >
          Поддержите проект
        </div>
      </div>
    </Box>
  );

  return (
    <React.Fragment key={drawerAnchor}>
      <Drawer
        anchor={drawerAnchor}
        open={showTemporaryDrawer}
        onClose={toggleDrawer}
        classes={{
          root: styles.root,
          paper: styles.paper,
        }}
      >
        {list()}
      </Drawer>
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  container: {
    marginTop: 52,
    paddingLeft: 30,
    paddingRight: 30,
  },
  paper: {
    background: '#FFE7D3',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 16,
    // fontFamily: 'Futura PT',
    // background: '#FEDDBE',
  },
  listItemGutters: {
    paddingLeft: 30,
    paddingRight: 30,
  },
  listItemTextRoot: {
    color: '#603004',
  },
  cta: {
    marginBottom: 20,
    width: '100%',
  },
  subscribe: {
    fontSize: 16,
    fontWeight: 600,
    fontFamily: 'Inter',
    color: '#603004',
    marginTop: 10,
  },
  newText: {
    fontSize: 12,
    fontWeight: 300,
    fontFamily: 'Inter',
    color: '#AF6521',
    marginTop: 10,
    marginBottom: 20,
  },
  button: {
    width: 135,
    padding: `10px 20px`,
    border: `1px solid #D0690D`,
    fontSize: 12,
    borderRadius: 5,
    color: '#603004',
    cursor: 'pointer',
    textAlign: 'center',
  },
  btnContainer: {},
  buttonFull: {
    width: 135,
    padding: `10px 0px`,
    border: `1px solid #D0690D`,
    backgroundColor: '#D0690D',
    fontSize: 12,
    borderRadius: 5,
    color: '#FFF',
    cursor: 'pointer',
    textAlign: 'center',
    marginTop: 60,
  },
}));
